module.exports = {
	"id": "GQ",
	"name": "Equatorial Guinea",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.08565,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.013704,
			"17": null,
			"18": 0.10278,
			"19": 0.003426,
			"20": null,
			"21": null,
			"22": 0.01713,
			"23": null,
			"24": 0.006852,
			"25": null,
			"26": 0.006852,
			"27": 0.003426,
			"28": 0.006852,
			"29": 0.003426,
			"30": 0.013704,
			"31": 0.023982,
			"32": 0.027408,
			"33": 0.030834,
			"34": 0.185004,
			"35": 0.157596,
			"36": 0.010278,
			"37": 0.003426,
			"38": 0.01713,
			"39": 0.041112,
			"40": 0.037686,
			"41": 0.058242,
			"42": 0.078798,
			"43": 0.219264,
			"44": 0.078798,
			"45": 0.294636,
			"46": 0.058242,
			"47": 0.047964,
			"48": 0.198708,
			"49": 1.065486,
			"50": 0.099354,
			"51": 0.41112,
			"52": 0.339174,
			"53": 9.154272,
			"54": 2.36394,
			"55": 0.003426,
			"56": 0.006852,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.161022,
			"4": 0.143892,
			"5": 0.061668,
			"6": 0.044538,
			"7": null,
			"8": 0.041112,
			"9": null,
			"10": null,
			"11": 0.006852,
			"12": null,
			"13": 0.006852,
			"14": 0.027408,
			"15": 0.010278,
			"16": 0.010278,
			"17": 0.006852,
			"18": 0.006852,
			"19": 0.05139,
			"20": null,
			"21": 0.010278,
			"22": 0.006852,
			"23": 0.065094,
			"24": 0.044538,
			"25": 0.010278,
			"26": 0.010278,
			"27": null,
			"28": 0.003426,
			"29": 0.023982,
			"30": 0.859926,
			"31": 0.56529,
			"32": 0.020556,
			"33": 0.05139,
			"34": 0.147318,
			"35": 0.140466,
			"36": 0.013704,
			"37": 0.126762,
			"38": 0.397416,
			"39": 0.03426,
			"40": 0.113058,
			"41": 0.089076,
			"42": 0.030834,
			"43": 0.664644,
			"44": 0.157596,
			"45": 0.424824,
			"46": 0.071946,
			"47": 0.969558,
			"48": 0.640662,
			"49": 2.990898,
			"50": 0.078798,
			"51": 0.006852,
			"52": null,
			"3.5": null,
			"3.6": 0.020556
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.006852,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.006852,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.010278,
			"35": 0.013704,
			"36": 0.013704,
			"37": 0.065094,
			"38": 0.010278,
			"39": 0.027408,
			"40": 0.219264,
			"41": 0.01713,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.003426,
			"12.1": 0.047964
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": 0.010278,
			"7": 0.006852,
			"8": 0.058242,
			"9": 0.041112,
			"10": 0.370008,
			"3.1": null,
			"3.2": null,
			"5.1": 0.05139,
			"6.1": null,
			"7.1": null,
			"9.1": 0.178152
		},
		"ios_saf": {
			"8": 0,
			"10": 1.11000977352,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0299134789759,
			"8.1-8.4": 0.0552638848876,
			"9.0-9.2": 0.0263644221482,
			"9.3": 0.402226440466
		},
		"android": {
			"3": 0,
			"4": 0.125568496124,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0156960620155,
			"4.1": 0.452943503876,
			"4.2-4.3": 1.13235875969,
			"4.4": 2.59657711628,
			"4.4.3-4.4.4": 2.61900006202
		},
		"ie": {
			"6": 0.0103806516854,
			"7": 0.0415226067416,
			"8": 0.480970194757,
			"9": 0.176471078652,
			"10": 0.373703460674,
			"11": 4.46022000749,
			"5.5": null
		},
		"op_mob": {
			"0": 1.85968448291,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0516579023029
		},
		"edge": {
			"12": 0.311766,
			"13": 0.763998,
			"14": 0.202134
		},
		"ie_mob": {
			"10": 0.0414810140845,
			"11": 0.168886985915
		},
		"bb": {
			"7": 0.0312265,
			"10": null
		},
		"samsung": {
			"0": 2.603304
		},
		"and_uc": {
			"0": 8.191204
		},
		"op_mini": {
			"0": 25.0552056148
		},
		"and_chr": {
			"0": 19.726758
		},
		"and_ff": {
			"0": 0.105184
		}
	},
	"total": 99.0263125
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/GQ.json
 ** module id = 536
 ** module chunks = 0
 **/